var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 54,
    viewBox: "0 0 49 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ct2apdu1ba"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9835",
    style: {
      fill: "none"
    },
    d: "M0 0h45.467v51.604H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9834",
    style: {
      fill: "none"
    },
    d: "M0 0h49v54H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10697"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10696",
    transform: "translate(1.766 1.197)",
    style: {
      clipPath: "url(#ct2apdu1ba)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42455",
    d: "M249.929 486.58h-15.3a3.84 3.84 0 0 0-3.072 1.526H220.13v4.035h.979q.132.625.286 1.243h9.4v1.087H222c.22.77.46 1.532.733 2.276a20.668 20.668 0 0 0 5.141 7.924h2.926v1.185h-1.91c.305.24.616.474.938.7s.639.426.967.624v3.33a3.819 3.819 0 0 0 3.836 3.8h15.3a3.819 3.819 0 0 0 3.836-3.8v-20.128a3.819 3.819 0 0 0-3.836-3.8",
    transform: "translate(-209.231 -462.704)",
    style: {
      fill: "#616161"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42456",
    d: "M222.729 649.666a32.634 32.634 0 0 1-.733-2.276h-1.866v10.2h7.74a20.671 20.671 0 0 1-5.141-7.924",
    transform: "translate(-209.231 -615.623)",
    style: {
      fill: "#454545"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42457",
    d: "M69.186 583.458h29.807v-3.284H66v-1.136h24.634a23.445 23.445 0 0 1-7.975-3.384 16.43 16.43 0 0 1-.938-.7H66v-1.136h5.52v-10.2H66v-1.136h8.229q-.392-1.572-.643-3.187h-8.6v19.992a4.115 4.115 0 0 0 .537 2.034 4.208 4.208 0 0 0 3.667 2.132",
    transform: "translate(-61.764 -531.854)",
    style: {
      fill: "#454545"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42458",
    d: "M92.149 624.936v.442h23.669v-.442h1.146v.442h7.744v-1.136H85.482v1.136H91v-.442z",
    transform: "translate(-81.25 -593.611)",
    style: {
      fill: "#141414"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42459",
    d: "M118.478 961.56h-33v1.14h33z",
    transform: "translate(-81.249 -914.377)",
    style: {
      fill: "#141414"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42460",
    d: "M124.708 855.263h-7.744v.287h-1.146v-.287H92.149v.287H91v-.287h-5.52v1.137h39.226z",
    transform: "translate(-81.25 -813.295)",
    style: {
      fill: "#141414"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42461",
    d: "m731.727 420.425-1.385 1.372h4.81l4.5-4.454v-2.285a.357.357 0 0 0-.359-.355H737.5l-.473.469-5.3 5.254",
    transform: "translate(-694.18 -394.353)",
    style: {
      fill: "#383838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42462",
    d: "m530.272 420.425-1.385 1.372h5.347l7.159-7.1h-5.347l-.473.469-5.3 5.254",
    transform: "translate(-502.7 -394.353)",
    style: {
      fill: "#383838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42463",
    d: "m338.375 420.425-1.385 1.375h4.874l7.159-7.1h-4.874l-.473.469-5.3 5.254",
    transform: "translate(-320.305 -394.353)",
    style: {
      fill: "#383838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42464",
    d: "M230.18 417.756a39.074 39.074 0 0 0 .415 4.043h.246L238 414.7h-4.74l-.473.469-2.607 2.584",
    transform: "translate(-218.783 -394.354)",
    style: {
      fill: "#383838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42465",
    d: "m49.167 558.606-.026-.01.026.01",
    transform: "translate(-46.708 -531.186)",
    style: {
      fill: "#4a206a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42466",
    d: "m151.875 476.913-2.694 2.67-1.385 1.372h4.494a39.078 39.078 0 0 1-.415-4.043",
    transform: "translate(-140.478 -453.511)",
    style: {
      fill: "#1f1f1f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42467",
    d: "m48.751 418.157 3.492-3.457H48.5c.005.065.01.13.01.2a2.6 2.6 0 0 1-2.615 2.592 2.631 2.631 0 0 1-.747-.109l-.247.244v3.816a.353.353 0 0 0 .2.315q1.828-1.794 3.647-3.6",
    transform: "translate(-42.682 -394.351)",
    style: {
      fill: "#1f1f1f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42468",
    d: "m53.793 421.787 1.385-1.372 2.694-2.67 2.607-2.584.473-.469h-4.915q-1.747 1.728-3.492 3.458-1.82 1.8-3.647 3.6h.012l.026.01a.346.346 0 0 0 .122.025h4.736z",
    transform: "translate(-46.475 -394.342)",
    style: {
      fill: "#141414"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42469",
    d: "M44.905 467.55v.331l.247-.244a2.578 2.578 0 0 1-.247-.086",
    transform: "translate(-42.682 -444.608)",
    style: {
      fill: "#281841"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42470",
    d: "M243.528 421.786h4.627l1.385-1.372 5.3-5.254.473-.469h-4.627z",
    transform: "translate(-231.47 -394.341)",
    style: {
      fill: "#141414"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42471",
    d: "m442.578 414.691-7.159 7.1h4.628l1.385-1.372 5.3-5.254.473-.469h-4.628z",
    transform: "translate(-413.859 -394.341)",
    style: {
      fill: "#141414"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42472",
    d: "M636.88 421.786h4.627l1.385-1.372 5.3-5.254.473-.469h-4.625z",
    transform: "translate(-605.346 -394.341)",
    style: {
      fill: "#141414"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42473",
    d: "M827.48 472.974h4.138a.356.356 0 0 0 .355-.338V468.518z",
    transform: "translate(-786.509 -445.53)",
    style: {
      fill: "#141414"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42474",
    d: "m693.874 7.885-.855 1.746 8.454-2.9-3.91 1.343 2.776-5.674 1.355 3.873-2.11-6.03a.359.359 0 0 0-.457-.219L697.439.6l-.292.6-3.273 6.685",
    transform: "translate(-658.706 -.004)",
    style: {
      fill: "#383838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42475",
    d: "m503.526 51.856-.855 1.746 1.769-.608 3.283-1.128 4.42-9.028-5.052 1.736-.292.6-3.273 6.685",
    transform: "translate(-477.782 -40.737)",
    style: {
      fill: "#383838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42476",
    d: "m325.491 111-3.273 6.685-.855 1.746 4.605-1.582 4.42-9.028-4.605 1.582z",
    transform: "translate(-305.451 -103.479)",
    style: {
      fill: "#383838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42477",
    d: "M149.307 172.419q-.215.453-.412.918a25.5 25.5 0 0 0-1.819 7.359l-4.474 1.537 4.479-1.539 4.42-9.028-4.479 1.539z",
    transform: "translate(-135.54 -163.243)",
    style: {
      fill: "#383838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42478",
    d: "m58.5 235.537-4.144 1.424z",
    transform: "translate(-51.666 -223.98)",
    style: {
      fill: "#5f2e7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42479",
    d: "M148.894 187.937q.2-.464.412-.918l-2.286.785-.292.6-3.273 6.685-.855 1.746 4.474-1.537a25.5 25.5 0 0 1 1.819-7.359",
    transform: "translate(-135.539 -177.842)",
    style: {
      fill: "#1f1f1f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42480",
    d: "m4.057 241.977 1-2.039 2.157-4.4-4.144 1.424-.294.6-1.529 3.124-.847-2.43 1.5 4.3a2.6 2.6 0 0 1 2.151-.577",
    transform: "translate(-.382 -223.98)",
    style: {
      fill: "#1f1f1f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42481",
    d: "m75.223 209-1 2.039a2.611 2.611 0 0 1 1.93 1.494l1.456-.5.855-1.746 3.273-6.685.292-.6-4.644 1.6q-1.08 2.2-2.157 4.4",
    transform: "translate(-70.544 -193.046)",
    style: {
      fill: "#141414"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42482",
    d: "m2.4 265.148.293-.6-2.45.842a.354.354 0 0 0-.222.452l.849 2.427 1.53-3.121",
    transform: "translate(0 -251.57)",
    style: {
      fill: "#141414"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42483",
    d: "m237.474 142.547-4.42 9.028 4.372-1.5.855-1.746 3.273-6.685.292-.6-.334.115-4.038 1.387z",
    transform: "translate(-221.515 -134.123)",
    style: {
      fill: "#141414"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42484",
    d: "m414.368 88.728 4.372-1.5.855-1.746 3.273-6.685.292-.6-4.372 1.5z",
    transform: "translate(-393.851 -74.361)",
    style: {
      fill: "#141414"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42485",
    d: "m604.71 22.749 4.372-1.5.855-1.746 3.273-6.685.292-.6-4.372 1.5-4.42 9.028z",
    transform: "translate(-574.769 -11.619)",
    style: {
      fill: "#141414"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42486",
    d: "m784.8 54.552 3.91-1.343a.355.355 0 0 0 .221-.452l-1.355-3.873z",
    transform: "translate(-745.942 -46.485)",
    style: {
      fill: "#141414"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42487",
    d: "M198.122 649.32v-10.929h-1.146v10.929z",
    transform: "translate(-187.223 -607.065)",
    style: {
      fill: "#141414"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42488",
    d: "M698.161 638.391v10.929h1.146v-10.929z",
    transform: "translate(-663.593 -607.066)",
    style: {
      fill: "#141414"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42489",
    d: "M14.782 371.08a2.6 2.6 0 0 0 2.615-2.592c0-.066-.005-.132-.01-.2a2.554 2.554 0 0 0-.218-.859 2.611 2.611 0 0 0-1.93-1.494 2.643 2.643 0 0 0-.457-.042 2.617 2.617 0 0 0-1.694.619 2.578 2.578 0 0 0 .7 4.369c.08.033.163.061.247.086a2.636 2.636 0 0 0 .747.109m-1.3-2.592a1.3 1.3 0 1 1 1.3 1.292 1.3 1.3 0 0 1-1.3-1.292",
    transform: "translate(-11.565 -347.943)",
    style: {
      fill: "#616161"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42490",
    d: "M41.262 393.674a1.3 1.3 0 1 0-1.3 1.292 1.3 1.3 0 0 0 1.3-1.292",
    transform: "translate(-36.741 -373.128)",
    style: {
      fill: "#2c2b2b"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPoint);
export default __webpack_public_path__ + "static/media/video_point.a34fba565c540ac94e16bbfe91db4e95.svg";
export { ForwardRef as ReactComponent };